import { type InputType, loanOptionsConstants } from 'config'
import { currentProductTypeOptionsMap } from 'hooks/useProductTypeOptions'
import { getLoanTypeMapForSelect } from 'reducers/loanDetail.reducer'

export const TermSheetPlaceholders: string[] = [
  'LoanAmount',
  '120%LoanAmount',
  'LTV',
  'BorrowerName',
  'BorrowerCompanyName',
  'BrokerStreet',
  'BrokerCity',
  'BrokerState',
  'BrokerZipCode',
  'LenderCompany',
  'SubjectPropertyAddress',
  'InterestRate',
  'LoanTerm',
  'DiscountFeePercent',
  'DiscountFeeAmount',
  'CashBorrowerAtClosing',
  'ExitFee',
  'ConstructionBudget',
  'ConstructionAmountFinanced',
  'BrokerFeeAmount',
  'BrokerFeePercent',
  'BrokerCompanyName',
  'UnderwritingFee',
  'BorrowerType',
  'TrustDate',
  'FiveLaterDate',
  'TodayDate',
  'LoanOfficerOrBrokerName',
  'EstimatedCreditScore',
  'CommitmentFee',
  'BreakUpFee',
  'DueDilligence',
  'MonthlyPaymentNonEscrow',
  'MonthlyPaymentWithEscrow',
  'PrepaymentPenalty',
  'PurchasePrice',
  'DSCRValue',
  'InitialLoanAmount',
  'LTC',
  'LTARV',
  'MonthlyPaymentInitialNonDutch',
  'BorrowerEntityTitle',
  'BorrowerPresentAddress',
  'AmortizationType',
  'AsIsValue',
  'ProcessingFeeAmount',
  'SixMonthsInterestPaymentReserve',
  'TenPercentConstructionBudget',
  'ProcessingFeePlusOriginatorFee',
]

export const fieldsInputs = (): Record<string, InputType> => {
  return {
    title: {
      title: 'Title',
      inputType: 'text',
      type: 'text',
      error: '',
      required: true,
      span: 1,
    },
    content: {
      title: 'Content',
      inputType: 'textarea',
      rows: 3,
      error: '',
      span: 2,
      required: true,
    },
  }
}

export const SheetTypeOptions = {
  termSheet: 'Term Sheet',
  preApproval: 'Pre-Approval',
} as const

export const DEFAULT_SHEET_TYPE = 'termSheet'
export const DEFAULT_DOCUMENT_TITLE = 'CONDITIONAL LOAN TERM SHEET'

export const TermSheetTemplateSourceOptions = {
  current: 'Use Current Template',
  docgen: 'Use from Docgen',
} as const

export const termSheetTypeInputs = (): Record<string, InputType> => {
  return {
    productType: {
      title: 'Product Type',
      inputType: 'select',
      hasDefaultOption: true,
      options: currentProductTypeOptionsMap(),
      error: '',
      required: true,
    },
    transactionType: {
      title: 'Transaction Type',
      inputType: 'select',
      hasDefaultOption: true,
      options: loanOptionsConstants.transactionType,
      error: '',
      required: true,
    },
    types: {
      title: 'Channel',
      inputType: 'multiselect',
      options: getLoanTypeMapForSelect(),
      error: '',
      required: true,
      defaultSelected: false,
    },
    sheetType: {
      title: 'Sheet Type',
      inputType: 'select',
      options: SheetTypeOptions,
      value: DEFAULT_SHEET_TYPE,
      error: '',
      required: true,
    },
  }
}

export interface ITermSheetFields {
  title: string
  content: string
}

export interface ILoanTermSheetTemp {
  id: number
  productType: string
  transactionType: string
  type: string
  types: Record<string, any>
  sheetType?: string
  documentTitle?: string
  headerText: string
  exhibitA: string
  hideExhibitA?: boolean
  fields: ITermSheetFields[]
  source?: 'current' | 'docgen'
  docgenTemplateName?: string | null
  createdAt?: string
  updatedAt?: string
}
